export const pageName = {
    RECENT : 'Fichiers récents',
    MYSHARES: 'Mes partages',
    MYFOLDERS: 'Mes dossiers',
    SHAREWITHME: 'Partagé avec moi',
    TRASH: 'Corbeille'
};